/**
 * @generated SignedSource<<060e9dd5755b2fcddf235c794b5fe2b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type recentFormsListItem_on_RequestForm$data = {
  readonly descriptionHtml: string | null | undefined;
  readonly id: string;
  readonly name: string | null | undefined;
  readonly portalId: string | null | undefined;
  readonly portalName: string | null | undefined;
  readonly " $fragmentType": "recentFormsListItem_on_RequestForm";
};
export type recentFormsListItem_on_RequestForm$key = {
  readonly " $data"?: recentFormsListItem_on_RequestForm$data;
  readonly " $fragmentSpreads": FragmentRefs<"recentFormsListItem_on_RequestForm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "recentFormsListItem_on_RequestForm",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "descriptionHtml"
    },
    {
      "kind": "ScalarField",
      "name": "portalName"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "portalId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "HelpLayoutRequestForm"
};

(node as any).hash = "b5d8c7e23b6e2eb41dd1dea2dec19c82";

export default node;
